import * as React from "react";
import { Button } from "@material-ui/core";

const button = ({
  variant = "contained",
  color = "primary",
  children,
  ...rest
}) => (
  <Button variant={variant} color={color} {...rest}>
    {children}
  </Button>
);

export default button;
